export type Retreat = {
  id: string;
  name: string;
  location: string;
  startDate: string;      // ISO "2026-05-16"
  endDate: string;        // ISO "2026-05-22"
  displayDates: string;   // "16–22 May 2026"
  heroImage: string;
  description: string;
  forYouIf: string;
  bookLink: string;
  brochureLink?: string;
  teamLink?: string;
  scarcityNote?: string;
  status?: 'nearly-sold-out' | 'booking-soon';
  isExternalBook?: boolean;
  type: 'cf' | 'partner'; // 'cf' = CF Organic Wellness owned; 'partner' = Niki collaborates
  partnerName?: string;   // e.g. "Yoga on the Edge" — shown in partner section
  partnerLogo?: string;   // path to logo in /public/images/
};

export const retreats: Retreat[] = [
  {
    id: "la-manga-june-05-2027",
    type: "cf",
    name: "The Art of Eating, Moving, Breathing & Being",
    location: "La Manga, Spain",
    startDate: "2027-06-05",
    endDate: "2027-06-05",
    displayDates: "5–11 June 2027",
    heroImage: "/images/laManga.webp",
    description:
      "The flagship retreat. Eight specialist practitioners, gut and liver cleansing protocols, IV therapy, Shiatsu, Ayurvedic massage, yoga, Wim Hof breathwork, cold exposure, and clinical hypnotherapy — all in one week in southern Spain.",
    forYouIf:
      "you want the deepest reset available, with real medical and naturopathic expertise in the room.",
    bookLink: "/retreats/book",
    brochureLink: "/images/La_Manga_2026.pdf",
    teamLink: "/retreats/team",
    scarcityNote: "Limited to 18 guests · spaces fill fast",
  },
  {
    id: "la-manga-june-12-2027",
    type: "cf",
    name: "The Art of Eating, Moving, Breathing & Being",
    location: "La Manga, Spain",
    startDate: "2027-06-12",
    endDate: "2027-06-18",
    displayDates: "12–18 June 2027",
    heroImage: "/images/laManga.webp",
    description:
      "The flagship retreat. Eight specialist practitioners, gut and liver cleansing protocols, IV therapy, Shiatsu, Ayurvedic massage, yoga, Wim Hof breathwork, cold exposure, and clinical hypnotherapy — all in one week in southern Spain.",
    forYouIf:
      "you want the deepest reset available, with real medical and naturopathic expertise in the room.",
    bookLink: "/retreats/book",
    brochureLink: "/images/La_Manga_2026.pdf",
    teamLink: "/retreats/team",
    scarcityNote: "Limited to 18 guests · spaces fill fast",
  },
  {
    id: "summer-solstice-june-2026",
    type: "partner",
    name: "Early Summer Solstice Half Day Retreat",
    location: "Flamingo Falls, Mobberley",
    startDate: "2026-06-14",
    endDate: "2026-06-14",
    displayDates: "Sun 14 June 2026",
    heroImage: "/images/flamingo-falls-hero.webp",
    description:
      "Celebrate the peak of the light at Flamingo Falls — a secret sub-tropical botanical oasis in Cheshire. Flowing yoga, restorative practice, nature immersion and seasonal nutrition to mark the solstice.",
    forYouIf:
      "you want a gentle, nourishing pause to celebrate the season and reconnect with yourself.",
    bookLink: "/retreats/summer-solstice-june-2026",
    scarcityNote: "Only 1 space remaining · 10am–2pm",
    status: "nearly-sold-out",
  },
  {
    id: "autumn-flamingo-sept-2026",
    type: "partner",
    name: "Early Autumn Equinox Half Day Retreat",
    location: "Flamingo Falls, Mobberley",
    startDate: "2026-09-12",
    endDate: "2026-09-12",
    displayDates: "Sat 12 Sept 2026",
    heroImage: "/images/flamingo-falls-hero.webp",
    description:
      "A gentle half-day retreat at Flamingo Falls to mark the shift into autumn — flowing yoga, restorative practice, nature immersion, and seasonal nutrition with Niki Charnock and Clare Broomhead.",
    forYouIf:
      "you want to slow down, soak up the last of the summer light, and set clear intentions for the season ahead.",
    bookLink: "/retreats/autumn-equinox-sept-2026",
    scarcityNote: "Limited spaces · 10am–2pm",
  },
  {
    id: "portugal-may-2026",
    type: "partner",
    partnerName: "Yoga on the Edge",
    partnerLogo: "/images/yogaontheedge.webp",
    name: "Ember and Earth",
    location: "Portugal",
    startDate: "2026-05-02",
    endDate: "2026-05-09",
    displayDates: "2–9 May 2026",
    heroImage: "/images/portugal.webp",
    description:
      "Yin meets Hatha and Ashtanga-inspired flow. Build inner strength while staying deeply rooted in calm, clarity, and connection.",
    forYouIf: "movement and yoga are at the heart of what you need.",
    bookLink: "https://yogaontheedge.co.uk/workshops-and-retreats/workshops-and-retreats/",
    brochureLink:
      "https://yogaontheedge.co.uk/wp-content/uploads/2025/07/YOTE-2026-Retreats-Brochure-mp4-2.mp4",
    isExternalBook: true,
  },
  {
    id: "portugal-sept-2026",
    type: "partner",
    partnerName: "Yoga on the Edge",
    partnerLogo: "/images/yogaontheedge.webp",
    name: "Breathe & Breakthrough",
    location: "Portugal",
    startDate: "2026-09-26",
    endDate: "2026-10-03",
    displayDates: "26 Sept – 3 Oct 2026",
    heroImage: "/images/portugal.webp",
    description:
      "Ashtanga, Yin, Rocket, and creative Vinyasa flow. Reconnect with your breath and break through personal limitations — on and off the mat.",
    forYouIf:
      "you want to challenge yourself physically and mentally through movement.",
    bookLink: "https://yogaontheedge.co.uk/workshops-and-retreats/workshops-and-retreats/",
    brochureLink: "/images/YOTE2026RetreatsBrochure.pdf",
    isExternalBook: true,
  },
];

export function getUpcomingRetreats(): Retreat[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return retreats
    .filter((r) => new Date(r.endDate) >= today)
    .sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    );
}
